.footer {
  margin-top: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input {
  width: 350px;
  margin: 0 auto;
  margin-top: 20px;
}

.inputField {
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
  padding: 12px 14px;
  border: 2px solid var(--gray-xl);
  border-radius: 8px;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
}

.inputField:focus {
  border-color: var(--blue-l);
}

.note {
  font-size: 14px;
  width: 400px;
  margin: 0 auto;
  margin-top: 25px;
}

.id {
  font-family: var(--font-bold);
}
